import router from "./router";
import store from "./store";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { getToken } from "@/utils/auth";

NProgress.configure({ showSpinner: false });

const whiteList = ["/guide", "/sign", "/auth-redirect", "/bind", "/register"];

router.beforeEach((to, from, next) => {
  NProgress.start();

  // 临时修改：移除登录检查，直接加载角色为1的路由
  // TODO: 后续恢复时删除此段代码，恢复下方注释的代码
  // if (to.path === '/sign') {
  //   // 如果是访问登录页，则直接跳转到首页
  //   next('/index');
  //   return;
  // }

  // 如果没有路由配置，先加载路由
  // if (store.getters.permission_routes.length === 0) {
  //   store.dispatch('GenerateRoutes').then(accessRoutes => {
  //     router.addRoutes(accessRoutes);
  //     next({...to, replace: true});
  //   });
  // } else {
  //   next();
  // }

  // 原始代码，后续恢复时取消注释
  if (getToken()) {
    if (store.getters.permission_routes.length > 0) {
      next();
    } else {
      store.dispatch("GenerateRoutes").then(accessRoutes => {
        router.addRoutes(accessRoutes);
        next({ ...to, replace: true });
      });
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      next(`/sign?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
